import React, { useEffect, useState } from "react";
import Card from "../ui/Card";
import { authFetch } from "../../lib/authFetch";

// Aviso del inicio de la tienda: los Turbos que Mercado Libre prometió para
// otro día (programados en Lynx). Si la tienda los entrega antes y el chofer
// los escanea con la app de Flex, ML los da «en camino» y hay que entregarlos
// ese mismo día. Sin Turbos programados, no se muestra nada.
export type TurboProgramado = { tracking: string | number | null; store_name: string | null; dia: string; desde: string | null; hasta: string | null };

const diaCorto = (d: string) => `${d.slice(8, 10)}/${d.slice(5, 7)}`;
const franja = (t: TurboProgramado) => (t.desde && t.hasta ? ` de ${t.desde} a ${t.hasta}` : "");

export default function TurbosProgramadosAviso({ token }: { token: string | null }) {
  const [turbos, setTurbos] = useState<TurboProgramado[]>([]);

  useEffect(() => {
    if (!token) return;
    let vivo = true;
    authFetch("/v2/turbo/seller/scheduled", { token })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (vivo && Array.isArray(j?.turbos)) setTurbos(j.turbos); })
      // Es un aviso: si no se puede traer, el inicio sigue igual.
      .catch(() => {});
    return () => { vivo = false; };
  }, [token]);

  if (!turbos.length) return null;
  return (
    <Card style={{ borderColor: "var(--warning, #d29922)" }}>
      <div role="status" style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <div style={{ fontSize: "16px", fontWeight: 800, color: "var(--text-primary)" }}>
          {turbos.length === 1 ? "Tenés 1 Turbo para otro día" : `Tenés ${turbos.length} Turbos para otro día`}
        </div>
        <div style={{ color: "var(--text-secondary)", fontSize: "14px" }}>
          No los entregues antes del día prometido. Si el chofer los escanea con la app de Flex, Mercado Libre los da en camino y hay que entregarlos ese mismo día.
        </div>
        <ul style={{ margin: 0, paddingLeft: "18px", color: "var(--text-primary)", fontSize: "14px" }}>
          {turbos.map((t, i) => (
            <li key={`${t.tracking ?? i}-${t.dia}`}>
              {t.tracking ?? "Turbo"}{t.store_name ? ` · ${t.store_name}` : ""}: el {diaCorto(t.dia)}{franja(t)}
            </li>
          ))}
        </ul>
      </div>
    </Card>
  );
}
